import BaseService from "./Base.Service";

class TimeClockService extends BaseService {
	constructor() {
		const model = {
			clocked_at: { type: String, required: true },
		};

		super("time-clock-entries", model);
	}

	async clock(note) {
		try {
			const { data } = await this.conn.axios.post(`/time-clock-entries/clock`, { note: note || null });
			return data;
		} catch (err) {
			return this.sendError("Erro ao registrar ponto", false, err);
		}
	}

	async today() {
		try {
			const { data } = await this.conn.axios.get(`/time-clock-entries/today`);
			return data;
		} catch (err) {
			return this.sendError("Erro ao buscar batidas de hoje", false, err);
		}
	}

	async listEntries(queryString) {
		try {
			const { data } = await this.conn.axios.get(`/time-clock-entries?${queryString}`);
			return data;
		} catch (err) {
			return this.sendError("Erro ao buscar batidas", false, err);
		}
	}

	async createAdjustment(body) {
		try {
			const { data } = await this.conn.axios.post(`/time-clock-adjustments`, body);
			return data;
		} catch (err) {
			return this.sendError("Erro ao solicitar ajuste", false, err);
		}
	}

	async listAdjustments(queryString = "") {
		try {
			const { data } = await this.conn.axios.get(`/time-clock-adjustments?${queryString}`);
			return data;
		} catch (err) {
			return this.sendError("Erro ao buscar solicitações de ajuste", false, err);
		}
	}

	async createDirectAdjustment(body) {
		try {
			const { data } = await this.conn.axios.post(`/time-clock-adjustments/direct`, body);
			return data;
		} catch (err) {
			return this.sendError("Erro ao criar ajuste de ponto", false, err);
		}
	}

	async approveAdjustment(id) {
		try {
			const { data } = await this.conn.axios.put(`/time-clock-adjustments/${id}/approve`);
			return data;
		} catch (err) {
			return this.sendError("Erro ao aprovar ajuste", false, err);
		}
	}

	async rejectAdjustment(id, rejectionReason) {
		try {
			const { data } = await this.conn.axios.put(`/time-clock-adjustments/${id}/reject`, { rejection_reason: rejectionReason });
			return data;
		} catch (err) {
			return this.sendError("Erro ao rejeitar ajuste", false, err);
		}
	}

	async createBankEvent(body) {
		try {
			const { data } = await this.conn.axios.post(`/time-bank-events`, body);
			return data;
		} catch (err) {
			return this.sendError("Erro ao lançar acerto de banco de horas", false, err);
		}
	}

	async listBankEvents(queryString = "") {
		try {
			const { data } = await this.conn.axios.get(`/time-bank-events?${queryString}`);
			return data;
		} catch (err) {
			return this.sendError("Erro ao buscar acertos de banco de horas", false, err);
		}
	}

	/**
	 * Query do período aceita as duas formas: uma string 'YYYY-MM' (mês calendário,
	 * usada pela tela do colaborador) ou { start, end } para um período livre.
	 */
	periodParams(period) {
		if (typeof period === "string") {
			return `reference=${period}`;
		}
		return `start_date=${period.start}&end_date=${period.end}`;
	}

	async getMirror(contractId, period) {
		try {
			const params = contractId
				? `contract_id=${contractId}&${this.periodParams(period)}`
				: this.periodParams(period);
			const { data } = await this.conn.axios.get(`/time-clock-reports/mirror?${params}`);
			return data;
		} catch (err) {
			return this.sendError("Erro ao gerar espelho de ponto", false, err);
		}
	}

	async getCompanyMirror(period) {
		try {
			const { data } = await this.conn.axios.get(`/time-clock-reports/company-mirror?${this.periodParams(period)}`);
			return data;
		} catch (err) {
			return this.sendError("Erro ao gerar espelhos de ponto", false, err);
		}
	}

	async getSettings() {
		try {
			const { data } = await this.conn.axios.get(`/time-clock-reports/settings`);
			return data;
		} catch (err) {
			return this.sendError("Erro ao buscar configuração de ponto", false, err);
		}
	}

	async updateSettings(body) {
		try {
			const { data } = await this.conn.axios.put(`/time-clock-reports/settings`, body);
			return data;
		} catch (err) {
			return this.sendError("Erro ao salvar o dia de fechamento", false, err);
		}
	}

	async listCltContracts() {
		try {
			const { data } = await this.conn.axios.get(`/time-clock-reports/clt-contracts`);
			return data;
		} catch (err) {
			return this.sendError("Erro ao buscar contratos CLT", false, err);
		}
	}
}

export default TimeClockService;
